import React, { useState } from "react";
import { TextField, Button, FormControlLabel, Radio } from "@mui/material";
import MainCalculatorsList from "../MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,   FirstAds,MobileUnderCalAds } from "../../Ads";
import { CalculatorsType } from "../ConstantsEN";
import SharedHelmet from "../../LandingPageEN/Helmet";
const TITLE = "Online VAT Calculator";
const DESCRIPTION = "Calculate VAT rates in the UK with our free online VAT calculator. Easily determine VAT amounts for your transactions.";
const KEYWORDS = "VAT, VAT calculator, VAT calc, calculate VAT, UK VAT, VAT rates";
const OG_URL = "https://do-calculate.com/calculator/en/vat/";
function VATCalculator() {
  const [saleValue, setSaleValue] = useState("");
  const [vtaRate, setVatRate] = useState("");
  const [isSaleInclusiveOfVAT, setIsSaleInclusiveOfVAT] = useState("false");
  const [saleValueError, setSaleValueError] = useState("");
  const [vtaRateError, setVatRateError] = useState("");
  const [vatResult, setVatResult] = useState("");
  const [totalvalue, setTotalValue] = useState("");
  const handleVtaRateChange = (event) => {
    const inputVat = event.target.value;
    if (inputVat !== "") {
      const parsedVat = parseInt(inputVat, 10);
      if (!isNaN(parsedVat) && parsedVat >= 1 && parsedVat <= 45) {
        setVatRate(inputVat);
        setVatRateError("");
      } else {
        setVatRate("");
        if (isNaN(parsedVat)) {
          setVatRateError("Make sure to enter a number");
        } else if (parsedVat < 18) {
          setVatRate(inputVat);
          setVatRateError("The VAT rate should be between 1% and 45%");
        } else if (parsedVat > 85) {
          setVatRate(inputVat);
          setVatRateError("The VAT rate should be between 1% and 45%");
        }
      }
    } else {
      setVatRate("");
      setVatRateError("");
    }
  };
  const handleSaleChange = (event) => {
    const inputSale = event.target.value;
    if (inputSale !== "") {
      if (!isNaN(inputSale)) {
        setSaleValue(inputSale);
        setSaleValueError("");
      } else {
        setSaleValue("");
        if (isNaN(inputSale)) {
          setSaleValueError("Make sure to enter a number");
        }
      }
    } else {
      setSaleValue("");
      setSaleValueError("");
    }
  };
  const handleReset = () => {
    setSaleValue("");
    setVatRate("");
    setIsSaleInclusiveOfVAT("false");
    setSaleValueError("");
    setVatRateError("");
    setVatResult("");
    setTotalValue("");
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSaleInclusiveOfVAT === "false") {
      const vatAmount = Number(saleValue) * (vtaRate / 100);
      const totalValue = Number(saleValue) * ((1 + vtaRate) / 100);
      setVatResult(Math.round(vatAmount));
      setTotalValue(Math.round(totalValue));
    } else if (isSaleInclusiveOfVAT === "true") {
      const vatAmount =
        (Number(saleValue) / (1 + vtaRate / 100)) * (vtaRate / 100);
      const totalValue = Number(saleValue);
      setVatResult(vatAmount.toFixed(2));
      setTotalValue(totalValue.toFixed(2));
    }
  };
  return (
    <div>
         <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "32px" }}
          >
            <h1 style={{ fontSize: "14px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  The Value Added Tax (VAT) Calculator is a tool to add or
                  subtract VAT from any sale amount. You don't have to worry
                  about the formulas for adding or subtracting VAT. The VAT
                  Calculator helps you find the final sale price and the VAT
                  amount in just a couple of clicks.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  VAT calculator
                </div>
                <hr />
                <br />
                <form onSubmit={handleSubmit}>
                  <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                    <TextField
                      label="sale Value"
                      name="saleValue"
                      type="number"
                      value={saleValue}
                      onChange={handleSaleChange}
                      error={!!saleValueError}
                      helperText={saleValueError}
                      inputProps={{
                        required: true,
                        placeholder: "140",
                      }}
                      sx={{
                        width: "130px",
                        ml: "10px",
                        bgcolor: "#f9f9f9",
                        "&  .MuiFormHelperText-root.Mui-error": {
                          backgroundColor: "rgb(229, 230, 227) !important",
                          color: "red",
                          margin: 0,
                          padding: "8px 0 0 41px",
                        },
                      }}
                      size="small"
                      color="success"
                    />
                    <div
                      style={{
                        borderRadius: "4px",
                        border: " 1px solid rgba(0, 0, 0, 0.23)",
                        backgroundColor: "#f9f9f9",
                        padding: "7.5px 12px",
                        userSelect: "none",
                        fontSize: "14px",
                      }}
                    >
                      $
                    </div>
                  </div>
                  <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                    <TextField
                      label="vtaRate"
                      name="vtaRate"
                      value={vtaRate}
                      onChange={handleVtaRateChange}
                      error={!!vtaRateError}
                      helperText={vtaRateError}
                      type="number"
                      inputProps={{
                        required: true,
                        placeholder: "65",
                      }}
                      sx={{
                        width: "130px",
                        ml: "10px",
                        bgcolor: "#f9f9f9",
                        "&  .MuiFormHelperText-root.Mui-error": {
                          backgroundColor: "rgb(229, 230, 227) !important",
                          color: "red",
                          margin: 0,
                          padding: "8px 0 0 41px",
                        },
                      }}
                      size="small"
                      color="success"
                    />
                    <div
                      style={{
                        borderRadius: "4px",
                        border: " 1px solid rgba(0, 0, 0, 0.23)",
                        backgroundColor: "#f9f9f9",
                        padding: "7.5px 12px",
                        userSelect: "none",
                        fontSize: "14px",
                      }}
                    >
                      %
                    </div>
                  </div>
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label >Sale includes VAT</label>
                    </b>
                    <div style={{ marginRight: "40px" }}>
                      <FormControlLabel
                        value={"false"}
                        control={
                          <Radio
                            color="success"
                            checked={isSaleInclusiveOfVAT === "false"}
                            onChange={(e) =>
                              setIsSaleInclusiveOfVAT(e.target.value)
                            }
                          />
                        }
                        label="No"
                        labelPlacement="start"
                      />
                      <FormControlLabel
                        value={"true"}
                        control={
                          <Radio
                            color="success"
                            checked={isSaleInclusiveOfVAT === "true"}
                            onChange={(e) =>
                              setIsSaleInclusiveOfVAT(e.target.value)
                            }
                          />
                        }
                        label="Yes"
                        labelPlacement="start"
                      />
                    </div>
                  </div>
                  <br />
                  <hr />
                  <div className="mb-3">
                    <Button
                      type="submit"
                      color="success"
                      sx={{
                        backgroundColor: "rgb(25,135,84)",
                        fontSize: "15px",
                        marginRight: "25px",
                        padding: "5px 25px",
                        color: "white",
                      }}
                    >
                      Calculate
                    </Button>
                    <Button
                      sx={{
                        backgroundColor: "rgb(108,117,125)",
                        fontSize: "15px",
                        marginRight: "25px",
                        padding: "5px 25px",
                        color: "white",
                      }}
                      onClick={handleReset}
                    >
                      Clear
                    </Button>
                  </div>
                </form>
              </div>
              <div className="col-12 col-md-7">
                {vatResult && totalvalue && (
                  <div className="alert alert-success">
                    <div>
                      <p>VAT Amount: {vatResult}$</p>
                      <p>Total Value: {totalvalue}$</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList
            CalculatorsTypeId={CalculatorsType.financialCalculators}
          ></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                {" "}
                Everything you need to know about value added tax{" "}
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>What is value added tax?</h2>
                </u>
                <br />
                <p>
                  VAT is an indirect tax imposed on a supply and importing goods
                  and services, with some exceptions. A tax applies Value added
                  tax in more than 160 countries around the world The additive
                  is a tax on consumption that is paid and collected at each
                  stage One of the stages of the supply chain, from when the
                  manufacturer purchases materials Raw until the retailer sells
                  the finished product to the consumer.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Value added tax calculation formula
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  There are two methods to calculate Value Added Tax (VAT). The
                  first is adding VAT to the sale price, and the second is
                  excluding VAT from the sale price. Let's look at each method:
                  <br/>                  Adding VAT to the sale price: This method is used when the
                  sale price does not include VAT. You can use the following
                  formulas to add VAT to the sale price:
                  <br />
                  - VAT Amount = Sale Price × (VAT Rate/100)
                  <br />
                  - Total Value = Sale Price × ((1 + VAT Rate/100))
                  <br/>                  Excluding VAT from the sale price: This method is used when
                  the sale price is inclusive of VAT. Here are the formulas to
                  exclude VAT from the sale price:
                  <br />
                  - VAT Amount = Sale Price × (VAT Rate/(100 + VAT Rate))
                  <br />- Total Value = Sale Price × (100/(100 + VAT Rate))
                </p>
                <hr />
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default VATCalculator;